__turbopack_context__.v({
  "actions": "ColdStartInvite-module__8Dsm5a__actions",
  "body": "ColdStartInvite-module__8Dsm5a__body",
  "inflow": "ColdStartInvite-module__8Dsm5a__inflow",
  "invite": "ColdStartInvite-module__8Dsm5a__invite",
  "note": "ColdStartInvite-module__8Dsm5a__note",
  "overlay": "ColdStartInvite-module__8Dsm5a__overlay",
  "secondary": "ColdStartInvite-module__8Dsm5a__secondary",
  "title": "ColdStartInvite-module__8Dsm5a__title",
});
